import {
  SCROLL_TO_REVIEWS,
  SCROLL_TO_SECTION,
  TOGGLE_SHORT_INFO,
  SHOW_PAGE,
} from '../constants/view';

export const scrollToReviewsAction = () => ({
  type: SCROLL_TO_REVIEWS,
});

export const scrollToSectionAction = (payload) => ({
  type: SCROLL_TO_SECTION,
  payload,
});

export const toggleShortInfoAction = () => ({
  type: TOGGLE_SHORT_INFO,
});

export const showPageAction = (payload) => ({
  type: SHOW_PAGE,
  payload,
});
